/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreatePaymentInvoiceModel } from '../models';
// @ts-ignore
import type { CreatePaymentInvoiceResponseModel } from '../models';
// @ts-ignore
import type { DeletePatientInvoiceInvoiceIdParameter } from '../models';
// @ts-ignore
import type { GetPaymentInvoiceDataResponseModel } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PGMode } from '../models';
// @ts-ignore
import type { PatchPaymentFormModel } from '../models';
// @ts-ignore
import type { PatchPaymentGatewayModel } from '../models';
// @ts-ignore
import type { PaymentFormModel } from '../models';
// @ts-ignore
import type { PaymentGateways } from '../models';
// @ts-ignore
import type { PaymentSettingsModel } from '../models';
// @ts-ignore
import type { PaymentSettingsModelSchema } from '../models';
// @ts-ignore
import type { PaymentSettingsPatchModel } from '../models';
// @ts-ignore
import type { PaymentSubmissionResponseModel } from '../models';
// @ts-ignore
import type { PaymentSubmissionSearchFilterModel } from '../models';
// @ts-ignore
import type { ShareInvoiceChannel } from '../models';
// @ts-ignore
import type { VerifyOTPResponseModel } from '../models';
// @ts-ignore
import type { VerifyPaymentModel } from '../models';
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to create a payment invoice
         * @summary Create a payment invoice
         * @param {CreatePaymentInvoiceModel} createPaymentInvoiceModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInvoice: async (createPaymentInvoiceModel: CreatePaymentInvoiceModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentInvoiceModel' is not null or undefined
            assertParamExists('createPatientInvoice', 'createPaymentInvoiceModel', createPaymentInvoiceModel)
            const localVarPath = `/api/v1/payments/patient/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentInvoiceModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to delete payment invoice
         * @summary delete payment invoice for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientInvoice: async (invoiceId: DeletePatientInvoiceInvoiceIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('deletePatientInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/payments/patient/invoice/{invoiceId}/delete`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to export the form submission details
         * @summary Export the details of particular paymentform filled by users
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayments: async (paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentSubmissionSearchFilterModel' is not null or undefined
            assertParamExists('exportPayments', 'paymentSubmissionSearchFilterModel', paymentSubmissionSearchFilterModel)
            const localVarPath = `/api/v1/payments/invoice/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentSubmissionSearchFilterModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get request data on the basis of given request Id
         * @summary get invoice data
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceData: async (invoiceId: DeletePatientInvoiceInvoiceIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoiceData', 'invoiceId', invoiceId)
            const localVarPath = `/public/api/v1/payments/patient/invoice/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get OTP for email verification
         * @summary Send OTP to the user email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOTP: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getOTP', 'email', email)
            const localVarPath = `/public/api/v1/payments/sendOTP`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * fetch all Payment Form
         * @summary Get list of Payment Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentForms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to fetch the Payment Gateways and Id of the enabled one
         * @summary Get list of Payment Gateways and there form fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentGateways: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get all the payment settings
         * @summary Get list of Payment Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get settings schema
         * @summary get payment settings schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSettingsSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/setting/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get the payment submission details
         * @summary Gets the details of payment form submissions
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments: async (paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentSubmissionSearchFilterModel' is not null or undefined
            assertParamExists('getPayments', 'paymentSubmissionSearchFilterModel', paymentSubmissionSearchFilterModel)
            const localVarPath = `/api/v1/payments/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentSubmissionSearchFilterModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * public api to that generates recaptcha token for form validation
         * @summary generate captcha token
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecaptcha: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getRecaptcha', 'email', email)
            const localVarPath = `/public/api/v1/payments/recaptcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update payment form details
         * @summary Patch Payment Form data
         * @param {string} formId 
         * @param {PatchPaymentFormModel} patchPaymentFormModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentForm: async (formId: string, patchPaymentFormModel: PatchPaymentFormModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('patchPaymentForm', 'formId', formId)
            // verify required parameter 'patchPaymentFormModel' is not null or undefined
            assertParamExists('patchPaymentForm', 'patchPaymentFormModel', patchPaymentFormModel)
            const localVarPath = `/api/v1/payments/form/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPaymentFormModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to patch gateway config
         * @summary Update PG config
         * @param {string} gatewayId 
         * @param {PatchPaymentGatewayModel} patchPaymentGatewayModel 
         * @param {PGMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentGateway: async (gatewayId: string, patchPaymentGatewayModel: PatchPaymentGatewayModel, mode?: PGMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gatewayId' is not null or undefined
            assertParamExists('patchPaymentGateway', 'gatewayId', gatewayId)
            // verify required parameter 'patchPaymentGatewayModel' is not null or undefined
            assertParamExists('patchPaymentGateway', 'patchPaymentGatewayModel', patchPaymentGatewayModel)
            const localVarPath = `/api/v1/payments/config/{gatewayId}`
                .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPaymentGatewayModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to patch payment settings
         * @summary Update payment setting
         * @param {PaymentSettingsPatchModel} paymentSettingsPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentSetting: async (paymentSettingsPatchModel: PaymentSettingsPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentSettingsPatchModel' is not null or undefined
            assertParamExists('patchPaymentSetting', 'paymentSettingsPatchModel', paymentSettingsPatchModel)
            const localVarPath = `/api/v1/payments/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentSettingsPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to accept payment submission from live form
         * @summary Accept payment form data from specific/generic link for live form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLivePaymentFormData: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postLivePaymentFormData', 'email', email)
            const localVarPath = `/public/api/v1/payments/submission/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to accpet payment submission from test form
         * @summary Upsert payment submission data from specific/generic link for test form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTestPaymentFormData: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postTestPaymentFormData', 'email', email)
            const localVarPath = `/public/api/v1/payments/submission/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to send payment request link
         * @summary send payment invoice link for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {ShareInvoiceChannel} [channel] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPatientInvoice: async (invoiceId: DeletePatientInvoiceInvoiceIdParameter, channel?: ShareInvoiceChannel, email?: string, phone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('sendPatientInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/payments/patient/invoice/{invoiceId}/send`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to process(iff required) and verify payment submission from live forms
         * @summary Verify the Payments from Live form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyLivePayment: async (verifyPaymentModel: VerifyPaymentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPaymentModel' is not null or undefined
            assertParamExists('verifyLivePayment', 'verifyPaymentModel', verifyPaymentModel)
            const localVarPath = `/public/api/v1/payments/submission/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPaymentModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to verify email OTP and send invoice data
         * @summary verify OTP send to given email
         * @param {number} oTP 
         * @param {string} email 
         * @param {string} [invoiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTP: async (oTP: number, email: string, invoiceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oTP' is not null or undefined
            assertParamExists('verifyOTP', 'oTP', oTP)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('verifyOTP', 'email', email)
            const localVarPath = `/public/api/v1/payments/verifyOTP`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oTP !== undefined) {
                localVarQueryParameter['OTP'] = oTP;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (invoiceId !== undefined) {
                localVarQueryParameter['invoiceId'] = invoiceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to process(iff required) and verify payment submission from test form
         * @summary Verify the Payments from test form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTestPayment: async (verifyPaymentModel: VerifyPaymentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPaymentModel' is not null or undefined
            assertParamExists('verifyTestPayment', 'verifyPaymentModel', verifyPaymentModel)
            const localVarPath = `/public/api/v1/payments/submission/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPaymentModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * API to create a payment invoice
         * @summary Create a payment invoice
         * @param {CreatePaymentInvoiceModel} createPaymentInvoiceModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientInvoice(createPaymentInvoiceModel: CreatePaymentInvoiceModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreatePaymentInvoiceResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientInvoice(createPaymentInvoiceModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createPatientInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to delete payment invoice
         * @summary delete payment invoice for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.deletePatientInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to export the form submission details
         * @summary Export the details of particular paymentform filled by users
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPayments(paymentSubmissionSearchFilterModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.exportPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get request data on the basis of given request Id
         * @summary get invoice data
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceData(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentInvoiceDataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceData(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getInvoiceData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get OTP for email verification
         * @summary Send OTP to the user email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOTP(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOTP(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getOTP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * fetch all Payment Form
         * @summary Get list of Payment Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentForms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFormModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentForms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to fetch the Payment Gateways and Id of the enabled one
         * @summary Get list of Payment Gateways and there form fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentGateways(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentGateways>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentGateways(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentGateways']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get all the payment settings
         * @summary Get list of Payment Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentSettingsModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get settings schema
         * @summary get payment settings schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentSettingsSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentSettingsModelSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentSettingsSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentSettingsSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get the payment submission details
         * @summary Gets the details of payment form submissions
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayments(paymentSubmissionSearchFilterModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * public api to that generates recaptcha token for form validation
         * @summary generate captcha token
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecaptcha(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecaptcha(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getRecaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update payment form details
         * @summary Patch Payment Form data
         * @param {string} formId 
         * @param {PatchPaymentFormModel} patchPaymentFormModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPaymentForm(formId: string, patchPaymentFormModel: PatchPaymentFormModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPaymentForm(formId, patchPaymentFormModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.patchPaymentForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to patch gateway config
         * @summary Update PG config
         * @param {string} gatewayId 
         * @param {PatchPaymentGatewayModel} patchPaymentGatewayModel 
         * @param {PGMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPaymentGateway(gatewayId: string, patchPaymentGatewayModel: PatchPaymentGatewayModel, mode?: PGMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPaymentGateway(gatewayId, patchPaymentGatewayModel, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.patchPaymentGateway']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to patch payment settings
         * @summary Update payment setting
         * @param {PaymentSettingsPatchModel} paymentSettingsPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPaymentSetting(paymentSettingsPatchModel: PaymentSettingsPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPaymentSetting(paymentSettingsPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.patchPaymentSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to accept payment submission from live form
         * @summary Accept payment form data from specific/generic link for live form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLivePaymentFormData(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentSubmissionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLivePaymentFormData(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.postLivePaymentFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to accpet payment submission from test form
         * @summary Upsert payment submission data from specific/generic link for test form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTestPaymentFormData(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentSubmissionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTestPaymentFormData(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.postTestPaymentFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to send payment request link
         * @summary send payment invoice link for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {ShareInvoiceChannel} [channel] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, channel?: ShareInvoiceChannel, email?: string, phone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPatientInvoice(invoiceId, channel, email, phone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.sendPatientInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to process(iff required) and verify payment submission from live forms
         * @summary Verify the Payments from Live form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyLivePayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyLivePayment(verifyPaymentModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.verifyLivePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to verify email OTP and send invoice data
         * @summary verify OTP send to given email
         * @param {number} oTP 
         * @param {string} email 
         * @param {string} [invoiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOTP(oTP: number, email: string, invoiceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyOTPResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOTP(oTP, email, invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.verifyOTP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to process(iff required) and verify payment submission from test form
         * @summary Verify the Payments from test form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTestPayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTestPayment(verifyPaymentModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.verifyTestPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * API to create a payment invoice
         * @summary Create a payment invoice
         * @param {CreatePaymentInvoiceModel} createPaymentInvoiceModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInvoice(createPaymentInvoiceModel: CreatePaymentInvoiceModel, options?: RawAxiosRequestConfig): AxiosPromise<Array<CreatePaymentInvoiceResponseModel>> {
            return localVarFp.createPatientInvoice(createPaymentInvoiceModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to delete payment invoice
         * @summary delete payment invoice for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientInvoice(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to export the form submission details
         * @summary Export the details of particular paymentform filled by users
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.exportPayments(paymentSubmissionSearchFilterModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get request data on the basis of given request Id
         * @summary get invoice data
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceData(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentInvoiceDataResponseModel> {
            return localVarFp.getInvoiceData(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get OTP for email verification
         * @summary Send OTP to the user email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOTP(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getOTP(email, options).then((request) => request(axios, basePath));
        },
        /**
         * fetch all Payment Form
         * @summary Get list of Payment Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentForms(options?: RawAxiosRequestConfig): AxiosPromise<PaymentFormModel> {
            return localVarFp.getPaymentForms(options).then((request) => request(axios, basePath));
        },
        /**
         * API to fetch the Payment Gateways and Id of the enabled one
         * @summary Get list of Payment Gateways and there form fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentGateways(options?: RawAxiosRequestConfig): AxiosPromise<PaymentGateways> {
            return localVarFp.getPaymentGateways(options).then((request) => request(axios, basePath));
        },
        /**
         * API to get all the payment settings
         * @summary Get list of Payment Setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSetting(options?: RawAxiosRequestConfig): AxiosPromise<PaymentSettingsModel> {
            return localVarFp.getPaymentSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * get settings schema
         * @summary get payment settings schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSettingsSchema(options?: RawAxiosRequestConfig): AxiosPromise<PaymentSettingsModelSchema> {
            return localVarFp.getPaymentSettingsSchema(options).then((request) => request(axios, basePath));
        },
        /**
         * API to get the payment submission details
         * @summary Gets the details of payment form submissions
         * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getPayments(paymentSubmissionSearchFilterModel, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * public api to that generates recaptcha token for form validation
         * @summary generate captcha token
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecaptcha(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getRecaptcha(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Update payment form details
         * @summary Patch Payment Form data
         * @param {string} formId 
         * @param {PatchPaymentFormModel} patchPaymentFormModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentForm(formId: string, patchPaymentFormModel: PatchPaymentFormModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPaymentForm(formId, patchPaymentFormModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to patch gateway config
         * @summary Update PG config
         * @param {string} gatewayId 
         * @param {PatchPaymentGatewayModel} patchPaymentGatewayModel 
         * @param {PGMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentGateway(gatewayId: string, patchPaymentGatewayModel: PatchPaymentGatewayModel, mode?: PGMode, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPaymentGateway(gatewayId, patchPaymentGatewayModel, mode, options).then((request) => request(axios, basePath));
        },
        /**
         * API to patch payment settings
         * @summary Update payment setting
         * @param {PaymentSettingsPatchModel} paymentSettingsPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentSetting(paymentSettingsPatchModel: PaymentSettingsPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPaymentSetting(paymentSettingsPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to accept payment submission from live form
         * @summary Accept payment form data from specific/generic link for live form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLivePaymentFormData(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentSubmissionResponseModel> {
            return localVarFp.postLivePaymentFormData(email, options).then((request) => request(axios, basePath));
        },
        /**
         * API to accpet payment submission from test form
         * @summary Upsert payment submission data from specific/generic link for test form
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTestPaymentFormData(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentSubmissionResponseModel> {
            return localVarFp.postTestPaymentFormData(email, options).then((request) => request(axios, basePath));
        },
        /**
         * API to send payment request link
         * @summary send payment invoice link for the given invoice id
         * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
         * @param {ShareInvoiceChannel} [channel] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, channel?: ShareInvoiceChannel, email?: string, phone?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendPatientInvoice(invoiceId, channel, email, phone, options).then((request) => request(axios, basePath));
        },
        /**
         * API to process(iff required) and verify payment submission from live forms
         * @summary Verify the Payments from Live form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyLivePayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyLivePayment(verifyPaymentModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to verify email OTP and send invoice data
         * @summary verify OTP send to given email
         * @param {number} oTP 
         * @param {string} email 
         * @param {string} [invoiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTP(oTP: number, email: string, invoiceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<VerifyOTPResponseModel> {
            return localVarFp.verifyOTP(oTP, email, invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to process(iff required) and verify payment submission from test form
         * @summary Verify the Payments from test form submissions
         * @param {VerifyPaymentModel} verifyPaymentModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTestPayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyTestPayment(verifyPaymentModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - interface
 * @export
 * @interface PaymentsApi
 */
export interface PaymentsApiInterface {
    /**
     * API to create a payment invoice
     * @summary Create a payment invoice
     * @param {CreatePaymentInvoiceModel} createPaymentInvoiceModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    createPatientInvoice(createPaymentInvoiceModel: CreatePaymentInvoiceModel, options?: RawAxiosRequestConfig): AxiosPromise<Array<CreatePaymentInvoiceResponseModel>>;

    /**
     * API to delete payment invoice
     * @summary delete payment invoice for the given invoice id
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    deletePatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to export the form submission details
     * @summary Export the details of particular paymentform filled by users
     * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    exportPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * API to get request data on the basis of given request Id
     * @summary get invoice data
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getInvoiceData(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentInvoiceDataResponseModel>;

    /**
     * API to get OTP for email verification
     * @summary Send OTP to the user email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getOTP(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * fetch all Payment Form
     * @summary Get list of Payment Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getPaymentForms(options?: RawAxiosRequestConfig): AxiosPromise<PaymentFormModel>;

    /**
     * API to fetch the Payment Gateways and Id of the enabled one
     * @summary Get list of Payment Gateways and there form fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getPaymentGateways(options?: RawAxiosRequestConfig): AxiosPromise<PaymentGateways>;

    /**
     * API to get all the payment settings
     * @summary Get list of Payment Setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getPaymentSetting(options?: RawAxiosRequestConfig): AxiosPromise<PaymentSettingsModel>;

    /**
     * get settings schema
     * @summary get payment settings schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getPaymentSettingsSchema(options?: RawAxiosRequestConfig): AxiosPromise<PaymentSettingsModelSchema>;

    /**
     * API to get the payment submission details
     * @summary Gets the details of payment form submissions
     * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * public api to that generates recaptcha token for form validation
     * @summary generate captcha token
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getRecaptcha(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Update payment form details
     * @summary Patch Payment Form data
     * @param {string} formId 
     * @param {PatchPaymentFormModel} patchPaymentFormModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    patchPaymentForm(formId: string, patchPaymentFormModel: PatchPaymentFormModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to patch gateway config
     * @summary Update PG config
     * @param {string} gatewayId 
     * @param {PatchPaymentGatewayModel} patchPaymentGatewayModel 
     * @param {PGMode} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    patchPaymentGateway(gatewayId: string, patchPaymentGatewayModel: PatchPaymentGatewayModel, mode?: PGMode, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to patch payment settings
     * @summary Update payment setting
     * @param {PaymentSettingsPatchModel} paymentSettingsPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    patchPaymentSetting(paymentSettingsPatchModel: PaymentSettingsPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to accept payment submission from live form
     * @summary Accept payment form data from specific/generic link for live form
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    postLivePaymentFormData(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentSubmissionResponseModel>;

    /**
     * API to accpet payment submission from test form
     * @summary Upsert payment submission data from specific/generic link for test form
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    postTestPaymentFormData(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentSubmissionResponseModel>;

    /**
     * API to send payment request link
     * @summary send payment invoice link for the given invoice id
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {ShareInvoiceChannel} [channel] 
     * @param {string} [email] 
     * @param {string} [phone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    sendPatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, channel?: ShareInvoiceChannel, email?: string, phone?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to process(iff required) and verify payment submission from live forms
     * @summary Verify the Payments from Live form submissions
     * @param {VerifyPaymentModel} verifyPaymentModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    verifyLivePayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to verify email OTP and send invoice data
     * @summary verify OTP send to given email
     * @param {number} oTP 
     * @param {string} email 
     * @param {string} [invoiceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    verifyOTP(oTP: number, email: string, invoiceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<VerifyOTPResponseModel>;

    /**
     * API to process(iff required) and verify payment submission from test form
     * @summary Verify the Payments from test form submissions
     * @param {VerifyPaymentModel} verifyPaymentModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    verifyTestPayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI implements PaymentsApiInterface {
    /**
     * API to create a payment invoice
     * @summary Create a payment invoice
     * @param {CreatePaymentInvoiceModel} createPaymentInvoiceModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createPatientInvoice(createPaymentInvoiceModel: CreatePaymentInvoiceModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createPatientInvoice(createPaymentInvoiceModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to delete payment invoice
     * @summary delete payment invoice for the given invoice id
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public deletePatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).deletePatientInvoice(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to export the form submission details
     * @summary Export the details of particular paymentform filled by users
     * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public exportPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).exportPayments(paymentSubmissionSearchFilterModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get request data on the basis of given request Id
     * @summary get invoice data
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getInvoiceData(invoiceId: DeletePatientInvoiceInvoiceIdParameter, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getInvoiceData(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get OTP for email verification
     * @summary Send OTP to the user email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getOTP(email: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getOTP(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * fetch all Payment Form
     * @summary Get list of Payment Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentForms(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentForms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to fetch the Payment Gateways and Id of the enabled one
     * @summary Get list of Payment Gateways and there form fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentGateways(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentGateways(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get all the payment settings
     * @summary Get list of Payment Setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentSetting(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get settings schema
     * @summary get payment settings schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentSettingsSchema(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentSettingsSchema(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get the payment submission details
     * @summary Gets the details of payment form submissions
     * @param {PaymentSubmissionSearchFilterModel} paymentSubmissionSearchFilterModel 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPayments(paymentSubmissionSearchFilterModel: PaymentSubmissionSearchFilterModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPayments(paymentSubmissionSearchFilterModel, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * public api to that generates recaptcha token for form validation
     * @summary generate captcha token
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getRecaptcha(email: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getRecaptcha(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update payment form details
     * @summary Patch Payment Form data
     * @param {string} formId 
     * @param {PatchPaymentFormModel} patchPaymentFormModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public patchPaymentForm(formId: string, patchPaymentFormModel: PatchPaymentFormModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).patchPaymentForm(formId, patchPaymentFormModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to patch gateway config
     * @summary Update PG config
     * @param {string} gatewayId 
     * @param {PatchPaymentGatewayModel} patchPaymentGatewayModel 
     * @param {PGMode} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public patchPaymentGateway(gatewayId: string, patchPaymentGatewayModel: PatchPaymentGatewayModel, mode?: PGMode, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).patchPaymentGateway(gatewayId, patchPaymentGatewayModel, mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to patch payment settings
     * @summary Update payment setting
     * @param {PaymentSettingsPatchModel} paymentSettingsPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public patchPaymentSetting(paymentSettingsPatchModel: PaymentSettingsPatchModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).patchPaymentSetting(paymentSettingsPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to accept payment submission from live form
     * @summary Accept payment form data from specific/generic link for live form
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public postLivePaymentFormData(email: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).postLivePaymentFormData(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to accpet payment submission from test form
     * @summary Upsert payment submission data from specific/generic link for test form
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public postTestPaymentFormData(email: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).postTestPaymentFormData(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to send payment request link
     * @summary send payment invoice link for the given invoice id
     * @param {DeletePatientInvoiceInvoiceIdParameter} invoiceId 
     * @param {ShareInvoiceChannel} [channel] 
     * @param {string} [email] 
     * @param {string} [phone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public sendPatientInvoice(invoiceId: DeletePatientInvoiceInvoiceIdParameter, channel?: ShareInvoiceChannel, email?: string, phone?: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).sendPatientInvoice(invoiceId, channel, email, phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to process(iff required) and verify payment submission from live forms
     * @summary Verify the Payments from Live form submissions
     * @param {VerifyPaymentModel} verifyPaymentModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public verifyLivePayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).verifyLivePayment(verifyPaymentModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to verify email OTP and send invoice data
     * @summary verify OTP send to given email
     * @param {number} oTP 
     * @param {string} email 
     * @param {string} [invoiceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public verifyOTP(oTP: number, email: string, invoiceId?: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).verifyOTP(oTP, email, invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to process(iff required) and verify payment submission from test form
     * @summary Verify the Payments from test form submissions
     * @param {VerifyPaymentModel} verifyPaymentModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public verifyTestPayment(verifyPaymentModel: VerifyPaymentModel, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).verifyTestPayment(verifyPaymentModel, options).then((request) => request(this.axios, this.basePath));
    }
}

